<!--
 * @Author: your name
 * @Date: 2020-06-02 15:35:43
 * @LastEditTime: 2022-09-26 14:07:14
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: 底部输入框
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/comment/commentField.vue
-->
<template>
  <div v-if="Object.keys(detailInfo).length">
    <div v-if="!isFocus" class="PublishComment">
      <van-search ref="commonSearch" :left-icon="require('./image/edit-icon.png')" class="speak"
                  placeholder="说点什么吧"
                  readonly shape="round" @focus="isFocusFun('3')"/>
      <div class="iconWrap">
        <!-- 评论 -->
        <span class="icon-item share1" @click="toComment">
          <img class="share2" src="./image/comment-icon.png"/>
          <span class="num">{{ fomatterNum(detailInfo.commentNum, false) || '评论' }}</span>
        </span>
        <!-- 收藏 -->
        <span class="icon-item" @click="clickCollectLikeHandle(1, detailInfo.collectState)">
          <img v-show="!detailInfo.collectState" src="./image/collect-icon.png"/>
          <img v-show="detailInfo.collectState" src="./image/collected-icon.png"/>
          <span class="num">{{ fomatterNum(detailInfo.collectNum, false) || '收藏' }}</span>
        </span>

        <!-- 点赞 -->
        <span class="icon-item" @click="clickCollectLikeHandle(2, detailInfo.likeState)">
          <img v-show="!detailInfo.likeState" src="./image/like-icon.png"/>
          <img v-show="detailInfo.likeState" src="./image/liked-icon.png"/>
          <span class="num">{{ fomatterNum(detailInfo.likeNum, false) || '点赞' }}</span>
        </span>
        <!-- 分享 -->
        <span class="icon-item share2" @click="clickCollectLikeHandle(3, false)">
          <img src="./image/share-icon.png"/>
          <span class="num">{{ fomatterNum(detailInfo.shareNum, false) || '分享' }}</span>
        </span>
        <slot name="audio"></slot>
      </div>
      <slot name="rightbtn"></slot>
    </div>
    <div v-show="isFocus" class="centerComment" @click="isBlur()">
      <div class="mask" @click="isBlur('1')" @touchmove.prevent @mousewheel.prevent></div>
      <div class="fieldWrap">
        <div class="fieldCon">
          <van-cell-group class="input-item">
            <van-field v-model="message" :autosize="{ maxHeight: 60, minHeight: 20 }" autofocus maxlength="500"
                       placeholder="说点什么吧" rows="1" type="textarea" @input="inputChange"/>
          </van-cell-group>
        </div>
        <div class="fieldTop">
          <span class="button" @click="submitAllComment">发送</span>
        </div>
      </div>
    </div>
    <!-- 分享 -->
    <HFshare ref="HFshareVideo"></HFshare>
  </div>
</template>

<style lang="less" scoped>
@import "./less/harvard.less";
@import "./less/commentField.less";
</style>

<script>
import {Debounce, fomatterNum, getCookie, globalGoLogin, isUserLogin, throttle,} from "@/assets/js/common.js";
import HFshare from "@/components/comment/share.vue";
import API from "@/utils/axiosApi/communityApi";

export default {
  data() {
    return {
      pageNameObj: {
        1: "哈佛视频",
        2: "奶娃百科",
        4: "亲子儿歌",
        5: "育儿音频",
        6: "凯淇育儿",
        10: "京城名医",
      },
      isFocus: false, //判断真是评论框是否展示
      message: "", //评论内容
      // isGoLogin:false,//是否去登录 不去登录:false / 去登录:true
      collectShow: false, //收藏
      userInfo: [],
      handleParams: {
        type: "babyAdd",
        number: this.$route.params.id,
      },
      curCollType: "",
      itemSetId: "",
      sceneId: "",
      requestId: "",
      type: "",
      lookTimer: null,
      readingTime: 0,
    };
  },
  computed: {},
  components: {HFshare},
  props: [
    "articalId",
    "tlabelName",
    "title",
    "module",
    "isGoLogin",
    "collectNum",
    "commentTotal",
    "videolike",
    "detailInfo",
    "currentTopicList",
  ],
  mounted() {
    var date = Date.parse(new Date());
    var id = this.getCookie("xmh_unionid");
    this.requestId = this.$md5(date + id);
    if (this.$http.hostName == "https://mom.feihe.com") {
      // 正式环境物料id和服务id
      if (this.$route.query.source == "home") {
        this.itemSetId = "16";
        this.sceneId = "32";
      } else if (this.$route.query.source == "baby") {
        this.itemSetId = "16";
        this.sceneId = "312";
      } else {
        this.itemSetId = "16";
        this.sceneId = "41";
      }
    } else {
      // uat环境物料id和服务id
      if (this.$route.query.source == "home") {
        this.itemSetId = "12";
        this.sceneId = "21";
      } else if (this.$route.query.source == "baby") {
        this.itemSetId = "12";
        this.sceneId = "303";
      } else {
        this.itemSetId = "12";
        this.sceneId = "296";
      }
    }
    // this.durationTime();
  },
  destroyed() {
    // this.durationTimeReport()
    clearTimeout(this.lookTimer);
  },
  watch: {
    isFocus: {
      handler() {
        if (this.isFocus) {
          // $('.input-item').css("height", "186px")
          // $('textarea').css('padding-top', '16px')
        } else {
          // $('.input-item').css("height", "")
          // $('textarea').css('padding-top', '')
        }
      },
    },
  },
  methods: {
    getCookie,
    fomatterNum,
    isLogin() {
      sessionStorage.setItem("toLogin", "1");
      globalGoLogin();
    },
    // 点赞/取消点赞
    clickCollectLikeHandle: Debounce(function (type, state) {
      // 收藏点赞，未登录跳转登录
      if (type == 1 || type == 2) {
        if (isUserLogin()) {
          return this.isLogin();
        }
      }
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (type == 3) {
        this.$refs.HFshareVideo.showShareVideo();
      }
      this.$emit("sensorsFn", type == 1 && "收藏" || type == 2 && "文章点赞" || "转发")
      API.searchLike(
          {},
          {
            contentId: this.articalId,
            crmId: this.userInfo.crm_id,
            state: !state,
            type: type,
          },
          (res) => {
            if (res.code === 200) {
              // type 1 收藏， 2 点赞， 3，分享， 4 浏览， 5 评论
              if (type == 1) {
                this.detailInfo.collectState = res.data.collectState;
                this.detailInfo.collectNum = res.data.collectNum;
                res.data.collectState && this.$toast({
                  duration: 2000,
                  message: "收藏成功，和千万星妈一起学习",
                  context: this,
                });
              } else if (type == 2) {
                this.detailInfo.likeState = res.data.likeState;
                this.detailInfo.likeNum = res.data.likeNum;
                res.data.likeState && this.$toast({
                  duration: 2000,
                  message: "点赞" + res.message
                });
              } else if (type == 3) {
                this.detailInfo.shareNum = res.data.shareNum;
              }
            }
          }
      );
    }),
    // 滑到评论处
    toComment: throttle(function () {
      this.$emit("sensorsFn", "评论")
      $("body,html").animate(
          {
            scrollTop: document.getElementsByClassName("commentWrap")[0].offsetTop,
          },
          150
      );
    }, 300),
    isFocusFun(type) {
      this.type = type;
      if (isUserLogin()) {
        // 判断是否登陆跳转用另一种方式
        this.isLogin();
      } else {
        this.$emit("sensorsFn", "评论框")
        $("body").css("position", "absolute");
        $("body").css("overflow", "hidden");
        this.isFocus = true;
        // 自动获取焦点
        this.$nextTick(() => {
          console.log($("textarea")[0])
          $("textarea")[0].focus();
        });
      }
    },
    isBlur(id) {
      if (id == "1") {
        this.isFocus = false;
        $("body").css("position", "initial");
        $("body").css("overflow", "");
      } else if (id == "2") {
      } else if (id == "3") {
      }
    },
    inputChange() {
      if (this.message.length >= 1) {
        $(".button").addClass("button2");
      } else if (this.message.length == 0) {
        $(".button").removeClass("button2");
      }
    },
    // 提交评论
    submitAllComment: Debounce(function () {
      if (!this.message) {
        this.$toast({
          duration: 2000,
          message: "请输入评论内容",
          context: this,
          getContainer: ".wrap"
        });
        return;
      }
      this.isFocus = false;
      if (this.message.length != 0) {
        const detailId = Number(location.pathname.replace(/[^0-9]/gi, "")); //当前视频的id

        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let headImg = this.getCookie("xmh_headimgurl");
        let nickName = this.getCookie("xmh_nickname");
        let openid = this.getCookie("xmh_openid");
        this.$http.post(
            "/comment/save",
            {},
            {
              itemId: this.articalId,
              comments: this.message,
              crmId: this.userInfo.crm_id,
              level: 1,
              headImgUrl: headImg,
              userName: nickName,
              openid: openid,
              module: this.module,
            },
            (res) => {
              if (res.code == "200") {
                this.message = "";
                $("body").css("position", "initial");
                $("body").css("overflow", "");
                $(".button").removeClass("button2");
                this.$emit("getAllComment");
                this.$emit("changeCommentNum", true);
                this.$toast({
                  duration: 2000,
                  message: "评论成功",
                  context: this,
                });
              } else {
                this.$toast({
                  duration: 2000,
                  message: "评论失败",
                  context: this,
                });
              }
            }, (err) => {
              console.log(err)
            }, 'lucky'
        );
      }
    }, 500),
    //修改热门好文收藏状态
    gethotState(id, state) {
      let hotStatus = JSON.parse(localStorage.getItem("hotStatus"));
      hotStatus.forEach((item, index) => {
        if (id == item.id) {
          hotStatus[index].state = state;
        }
      });
      localStorage.setItem("hotStatus", JSON.stringify(hotStatus));
    },
  },
};
</script>
